import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { LoadingService } from 'src/app/_services/loading.service';
import { NotificationService } from 'src/app/_services/notification.service';
import { CategoryService } from '../../_ecomservices/category.service';
import { MatDialogRef, MatTableDataSource } from '@angular/material';
import { ProductCreateComponent } from '../product-create/product-create.component';

@Component({
  selector: 'app-category-create',
  templateUrl: './category-create.component.html',
  styleUrls: ['./category-create.component.css']
})
export class CategoryCreateComponent implements OnInit {

  cat_img: File = null;
  categoryImagePreview: string | ArrayBuffer | null = null;

  cat_banner: File = null;
  categoryBannerImagePreview: string | ArrayBuffer | null = null;

  categoryList:any = [];

  constructor(private dialogRef: MatDialogRef<ProductCreateComponent>,
    private titleService: Title,
    public categoryService: CategoryService,
    private loading : LoadingService,
    private notificationService: NotificationService,) {
   }

  ngOnInit() {
    this.titleService.setTitle('Category Create');
    this.onLoadCategories();
  }

  onLoadCategories() {
    var result = this.categoryService.get_categories().subscribe(data=> {
      this.categoryList = data['categoryList'];
      this.loading.spin$.next(false);
    });
  }

  onSelectCategoryImageFile(event: any): void {
    const file = event.target.files[0];
    if (file) 
    {
      this.cat_img = file;
      const reader = new FileReader();
      reader.onload = () => {
        this.categoryImagePreview = reader.result;
      };
      reader.readAsDataURL(file);
    }
  }

  onSelectCategoryBannerImageFile(event: any): void {
    const file = event.target.files[0];
    if (file) 
    {
      this.cat_banner = file;
      const reader = new FileReader();
      reader.onload = () => {
        this.categoryBannerImagePreview = reader.result;
      };
      reader.readAsDataURL(file);
    }
  }

  onCategoryFormSubmit(formData: any)
  {
    if(this.categoryService.category_form.valid)
    {
      if(this.cat_img){
        this.loading.spin$.next(true);
        this.categoryService.insert_category(formData, this.cat_img, this.cat_banner).subscribe(data=>{
          console.log(data);
          if (data['status']) {
            this.notificationService.success(data['message']); 
            this.categoryService.category_form.reset();
            this.onClose();
            this.loading.spin$.next(false);
          } 
          else {
            this.notificationService.error(data['error_message']);
            this.loading.spin$.next(false);
          }
        });
      }
      else{
        this.notificationService.error('Please upload category image');
      }
    }
  }

  onClose()
  {
    this.categoryService.category_form.reset();
    this.dialogRef.close();  
  }

  onFileChange(e){
    
  }

}
